import HandTiles from "./HandTiles";
import { sortEntries } from "../cardData";

export default function WinsListModal({hand,entries,witnessEnabled,onOpenEntry,onAddNew,onDeleteEntry,onClose}){
  const sorted=sortEntries(entries||[]);
  const fmtDate=(d)=>{if(!d)return "No date";try{const dt=new Date(d+"T12:00:00");return dt.toLocaleDateString(undefined,{month:"short",day:"numeric",year:"numeric"});}catch(e){return d;}};
  const statusFor=(e)=>{
    if(!witnessEnabled)return null;
    if(e.status==="confirmed")return{label:"verified",color:"var(--green)"};
    if(e.status==="pending")return{label:"pending",color:"var(--concealed)"};
    if(e.status==="unverified")return{label:"unverified",color:"var(--red)"};
    return null;
  };
  return(
    <div className="modal-overlay-center" onClick={onClose}><div className="modal-card" onClick={e=>e.stopPropagation()}>
      <div style={{textAlign:"center",marginBottom:4}}>
        <svg width="32" height="32" viewBox="0 0 18 16" fill="none">
          <path d="M5 2h8v5c0 2.5-1.5 4-4 4s-4-1.5-4-4V2z" fill="#C9A96E"/>
          <path d="M5 4H3c0 2 1 3 2 3" stroke="#C9A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M13 4h2c0 2-1 3-2 3" stroke="#C9A96E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <line x1="9" y1="11" x2="9" y2="13" stroke="#C9A96E" strokeWidth="1.5" strokeLinecap="round"/>
          <line x1="6" y1="14" x2="12" y2="14" stroke="#C9A96E" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      </div>
      <div className="modal-title" style={{textAlign:"center",marginBottom:4}}>Wins on this hand</div>
      <div style={{textAlign:"center",fontSize:15,fontWeight:600,letterSpacing:0.5,marginBottom:4}}><HandTiles groups={hand.groups}/></div>
      <div style={{textAlign:"center",fontSize:13,color:"var(--text-muted)",marginBottom:12}}>{sorted.length} {sorted.length===1?"win":"wins"} logged</div>
      <div style={{display:"flex",flexDirection:"column",gap:6,marginBottom:12,maxHeight:"40vh",overflowY:"auto"}}>
        {sorted.map(entry=>{
          const st=statusFor(entry);
          return(
            <div key={entry.id} style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"var(--radius-sm)",padding:"10px 12px",display:"flex",justifyContent:"space-between",alignItems:"center",gap:8}}>
              <div style={{flex:1,minWidth:0,cursor:"pointer"}} onClick={()=>onOpenEntry(entry)}>
                <div style={{fontSize:14,fontWeight:500}}>{fmtDate(entry.date)}</div>
                <div style={{fontSize:13,color:"var(--text-muted)",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{entry.location||"—"}</div>
              </div>
              {st&&<div style={{fontSize:11,color:st.color,fontWeight:600,fontStyle:st.label==="pending"?"italic":"normal"}}>{st.label}</div>}
              <div style={{cursor:"pointer",color:"var(--text-muted)",fontSize:18,padding:"0 4px",userSelect:"none"}} onClick={(e)=>{e.stopPropagation();onDeleteEntry(entry.id);}} title="Delete this win">{"×"}</div>
            </div>
          );
        })}
      </div>
      <button className="modal-save-btn" onClick={onAddNew}>+ Log another win</button>
      <div className="modal-cancel" onClick={onClose}>Close</div>
    </div></div>
  );
}
